import { createFileRoute } from "@tanstack/react-router";
import CrmLogin from "@/pages/crm/CrmLogin";

export const Route = createFileRoute("/crm/login")({
  head: () => ({
    meta: [
      { title: "Acceso CRM | SEOEVOLUTION" },
      { name: "description", content: "Acceso privado al panel CRM de SEOEVOLUTION." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { property: "og:url", content: "https://agenciaseoevolution.com/crm/login" },
      { property: "og:title", content: "Acceso CRM | SEOEVOLUTION" },
      { property: "og:description", content: "Acceso privado al panel CRM de SEOEVOLUTION." },
      { name: "twitter:title", content: "Acceso CRM | SEOEVOLUTION" },
      { name: "twitter:description", content: "Acceso privado al panel CRM de SEOEVOLUTION." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/crm/login" }],
  }),
  component: CrmLogin,
});
